// Create a GSAP timeline to synchronize animations
var elements = document.querySelectorAll(".custom_text span");

    // Function to remove the 'active' class
function removeActiveClass() {
  elements.forEach(function(element) {
    element.classList.remove("active");
  });
}

// Set a timeout to remove the class after 3 seconds
setTimeout(removeActiveClass, 3100); // 3000 milliseconds = 3 seconds

function greenSockTimeline() {
  const tl = gsap.timeline({
    // delay: 5,
  });
  
  
  // Select the elements to animate
  const div1 = document.getElementById("home-hero-your-text");
  const div2 = document.getElementById("home-hero-for-text");
  const button = document.getElementById("home-hero-explore-button");
  
  // Select the individual option elements within div1 and div2
  const options1 = Array.from(div1.querySelectorAll(".custom_text_span"));
  const options2 = Array.from(div2.querySelectorAll(".custom_text_span_set_two"));
  const links = button.querySelectorAll("a");
  
  // Create animations for the option elements and add them to the same timeline
  tl.add('start');
  tl.to(options1, { opacity: 0, translateY: 50, duration: 1 }, 'start');
  tl.to(options2, { opacity: 0, translateY: 50, duration: 1 }, 'start');
  
  // Create a separate animation for the button's display and add it to the same timeline
  // tl.to(button, { display: "block", duration: 1 });
  
  // Add event listeners to cycle through options
  let currentIndex1 = 0;
  let currentIndex2 = 0;
  let currentIndex3 = 0;
  
  // Function to add and remove "active" class to links
  const updateActiveLinks = () => {
    links.forEach((link, index) => {
      if (index === currentIndex3) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });
  };
  
  const cycleOptions = () => {
    // Update the current index and cycle back to 0 if necessary
    currentIndex1 = (currentIndex1 + 1) % options1.length;
    currentIndex2 = (currentIndex2 + 1) % options2.length;
    currentIndex3 = (currentIndex3 + 1) % links.length;
  
    // Update the opacity and translateY of the option elements
    options1.forEach((option, index) => {
      if (index === currentIndex1) {
        gsap.to(option, { opacity: 1, translateY: 0, duration: 1 });
      } else {
        gsap.to(option, { opacity: 0, translateY: 50, duration: 1 });
      }
    });
    options2.forEach((option, index) => {
      if (index === currentIndex2) {
        gsap.to(option, { opacity: 1, translateY: 0, duration: 1 });
      } else {
        gsap.to(option, { opacity: 0, translateY: 50, duration: 1 });
      }
    });
  
    updateActiveLinks(); 
  };
  
  // Call cycleOptions to initialize the initial state
  cycleOptions();
  
  // Set an interval to cycle through options at a specified interval
  setInterval(cycleOptions, 3000); // Change the interval as needed

}

setTimeout(greenSockTimeline, 3000); // 3000 milliseconds = 3 seconds

